import { Component, OnInit } from '@angular/core';
import { Congreso } from '../../models/congreso.model';
import { ActivatedRoute } from '@angular/router';
import { CongresosService, NotificationsService } from '../../services/services.index';
import { Notification } from '../../models/notification.model';

import * as _swal from 'sweetalert';
import { SweetAlert } from 'sweetalert/typings/core';
const swal: SweetAlert = _swal as any;

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styles: []
})
export class NotificationsComponent implements OnInit {

  congreso: Congreso = new Congreso();
  loading: boolean = true;
  notifications: Notification[];
  totalRegistros: number;

  constructor(private activatedRoute: ActivatedRoute,
    public _congresosService: CongresosService,
    public _notificationsService: NotificationsService) { }

  ngOnInit() {
    this.loading = true;
    this.activatedRoute.params.subscribe( params => {
      let congresoId: any = params['congreso'];
      this._congresosService.getCongreso(congresoId).subscribe((data: any) => {
        this.congreso = data.congreso;
        this.loadNotifications();
        this.loading = false;
      });
    });
  }

  loadNotifications() {
    this._notificationsService.getNotifications(this.congreso._id).subscribe((resp: any) => {
      this.notifications = resp.notifications;
      this.totalRegistros = resp.total;
    });
  }

  getDateFormat(timestamp: number) {
    return new Date(timestamp);
  }

  borrarNotification(notification: Notification) {
    this._notificationsService.borrarNotification(notification).subscribe((resp: Notification) => {
      this.loadNotifications();
      swal('Notificacion Borrada', 'La notificacion fue borrada correctamente', 'success');
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/notifications/notifications.component.ts